"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.snackbarComponents = void 0;
const Snackbars_1 = require("./Snackbars");
exports.snackbarComponents = {
    expandedSuccess: Snackbars_1.Snackbar,
    expandedDefault: Snackbars_1.Snackbar,
    expandedError: Snackbars_1.Snackbar,
    expandedInfo: Snackbars_1.Snackbar,
    expandedWarning: Snackbars_1.Snackbar,
    default: Snackbars_1.Snackbar,
    success: Snackbars_1.Snackbar,
    error: Snackbars_1.Snackbar,
    warning: Snackbars_1.Snackbar,
    info: Snackbars_1.Snackbar,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcG9uZW50cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1NuYWNrYmFyL2NvbXBvbmVudHMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQU1ILDJDQUF1QztBQUUxQixRQUFBLGtCQUFrQixHQUczQjtJQUNGLGVBQWUsRUFBRSxvQkFBUTtJQUN6QixlQUFlLEVBQUUsb0JBQVE7SUFDekIsYUFBYSxFQUFFLG9CQUFRO0lBQ3ZCLFlBQVksRUFBRSxvQkFBUTtJQUN0QixlQUFlLEVBQUUsb0JBQVE7SUFDekIsT0FBTyxFQUFFLG9CQUFRO0lBQ2pCLE9BQU8sRUFBRSxvQkFBUTtJQUNqQixLQUFLLEVBQUUsb0JBQVE7SUFDZixPQUFPLEVBQUUsb0JBQVE7SUFDakIsSUFBSSxFQUFFLG9CQUFRO0NBQ2YsQ0FBQyJ9